import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

import { helpers } from 'styles'

export const Count = styled.div`
	border-radius: 4px;
	border: 1px solid ${helpers.color.border};
	height: 38px;
	width: 38px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: ${helpers.font.size.large};
	line-height: 1px;
	font-weight: 500;
	color: ${helpers.color.text};

	${mobileMediaQuery(css`
		font-size: ${helpers.font.size.base};
		height: 32px;
		width: 32px;
	`)}
`
